<template>
  <div class="layout single-select">
    <div class="column">
      <h1 v-if="config.title" class="title">
        {{ $t(config.title, "options.title") }}
        <span
          class="tooltip"
          v-if="config.tooltip"
          :content="$t(config.tooltip, 'tooltip')"
          ><ion-icon name="help-circle-outline"></ion-icon
        ></span>
      </h1>
      <h1 key="question">{{ $t(config.question, "options.question") }}</h1>
    </div>
    <div :class="['column multi-select-column', columnStyle]">
      <transition-group
        appear
        name="options"
        v-on:before-appear="beforeEnter"
        tag="ul"
        class="question-set"
        v-bind:css="false"
      >
        <li
          role="button"
          v-bind:class="{ selected: isSelected(answer) }"
          :tabindex="i + 1"
          v-on:keyup.enter="select(answer)"
          v-on:click.once.stop="select(answer)"
          :key="answer.value"
          v-for="(answer, i) in config.answers"
          :data-index="i"
          :style="buttonStyle"
        >
          <span class="label">{{
            $t(answer.label, `options.answers.${answer.key}.label`)
          }}</span>
          <span class="icon">
            <ion-icon
              :style="{
                color: isSelected(answer)
                  ? theme.selected.backgroundColor
                  : null
              }"
              name="checkmark-circle-outline"
            ></ion-icon>
          </span>
        </li>
      </transition-group>
    </div>
  </div>
</template>

<script>
import Velocity from "velocity-animate";
import Vue from "vue";
import TranslationMixin from "../lib/TranslationMixin";

export default {
  name: "SingleSelect",
  props: ["config"],
  inject: ["convince", "theme"],
  mixins: [TranslationMixin],
  data: function() {
    return {
      currentSelection: null,
      complete: false
    };
  },
  computed: {
    columnStyle() {
      return "multi-select-columns-" + this.columnCount;
    },
    buttonStyle() {
      return {
        borderRadius: this.theme.borderRadius + "px"
      };
    }
  },
  methods: {
    isSelected(answer) {
      return (
        this.currentSelection && this.currentSelection.value === answer.value
      );
    },
    select(answer) {
      if (this.complete === true) {
        return;
      }
      this.complete = true;
      this.currentSelection = answer;
      let score = answer.score || 0;
      this.$store.dispatch("save", {
        key: this.config.key,
        answer: { value: this.currentSelection.value, score: score }
      });
      this.$emit("answer");
      setTimeout(this.leave, 500);
    },
    leave() {
      let answer = this.currentSelection;
      this.$gtag.event("answer", {
        event_category: "survey",
        event_label: this.config.key,
        value: this.currentSelection
      });
      if (typeof answer.next !== "undefined" && answer.next) {
        this.$store.commit("setIndex", this.getNext(answer.next));
      } else if (typeof this.config.next !== "undefined" && this.config.next) {
        this.$store.commit("setIndex", this.getNext(this.config.next));
      } else {
        this.$store.commit("advance");
      }
    },
    beforeEnter: function(el, done) {
      Velocity(
        el,
        { opacity: 0, translateY: "100%", translateZ: 0 },
        { duration: 0 }
      );
      var delay = 500 + el.dataset.index * 150;
      setTimeout(function() {
        Velocity(
          el,
          { opacity: 1, translateY: "0%", translateZ: 0 },
          { complete: done, duration: 550 }
        );
      }, delay);
    },
    addHover(i, event) {
      event.target.style.backgroundColor = this.theme.selected.backgroundColor;
      event.target.style.color = this.theme.selected.color;
      let icon = event.target.querySelector("span.icon");
      icon.classList.add("selected-icon");
      event.currentTarget.classList.add("hover");
    },
    removeHover(i, event) {
      if (event.currentTarget.classList.contains("selected")) {
        return;
      }
      event.target.style.backgroundColor = null;
      event.target.style.color = null;
      event.currentTarget.classList.remove("hover");
      let icon = event.target.querySelector("span.icon");
      icon.classList.remove("selected-icon");
    },
    mergeProperties(ob, newOb) {
      for (let prop in newOb) {
        Vue.set(ob, prop, newOb[prop]);
      }
    }
  },
  mounted() {
    this.currentSelection = null;
    window.scroll(0, 0);
  },
  created() {
    if (typeof this.config.columns !== "undefined") {
      this.columnCount = this.config.columns;
    } else {
      this.columnCount = 1;
    }
  }
};
</script>

<style lang="scss">
@import "../scss/components/survey";
</style>
